import { Location } from '@libs/models/locations';
import { request } from '../request';

export async function updateLocation(id: string, data: Location) {
  return request.patch<void>(`/v2/settings/locations/${id}`, data);
}
